import axios from "axios";
// https://staging.digitalhire.com // Staging
// https://api.digitalhire.com // Production
//baseURL: "http://localhost:4000",
export default axios.create({
  baseURL: "https://digitalhire.iqsoft.io",
});
